export enum CookieInfo {
  MAX_AGE = 60 * 60 * 24,
  // TODO colocar 1 mes (60 * 60 * 24 * 30)
}
